import React from 'react';
import { MainLayout } from '~/layout';
import { useAuth } from '~/providers/auth';
import { useUser } from '~/providers/user';
import { useWebsocket } from '~/providers/websocket';
import Permissions from '~/settings/permissions';
import Landing from './landing';
const ProtectedRoute = (props) => {
    const { children } = props;
    const { isAuthenticated } = useAuth();
    const { hasUserInfo, hasPermission, permissions } = useUser();
    const { isWebsocketReady } = useWebsocket();
    const appReady = isAuthenticated &&
        hasUserInfo &&
        isWebsocketReady &&
        !hasPermission(Permissions.INITIAL_DEFAULT_LIMITED_ACCESS) &&
        permissions.length !== 0;
    if (!appReady) {
        return React.createElement(Landing, null);
    }
    return React.createElement(MainLayout, null,
        React.createElement(React.Fragment, null, children));
};
export default ProtectedRoute;
